export default "__VITE_ASSET__56c45098__"